import Nav from "../components/Nav/nav";
import MainDash from "../components/Dash/mainDash";
import Whatsapp from "../Whatsapp/whatsapp";
const Dashboard = () => {
  return (
    <div>
      <Nav />
      <MainDash />
      <Whatsapp/>
    </div>
  );
};

export default Dashboard;
